import { render } from "./Employee_Deductions.vue?vue&type=template&id=f2870c2a"
import script from "./Employee_Deductions.vue?vue&type=script&lang=js"
export * from "./Employee_Deductions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__